import React, { useEffect, useState } from 'react';

function diff(target) {
  const now = new Date();
  const d = Math.max(0, target - now);
  return {
    days: Math.floor(d / (1000 * 60 * 60 * 24)),
    hrs: Math.floor((d / (1000 * 60 * 60)) % 24),
    mins: Math.floor((d / (1000 * 60)) % 60),
    secs: Math.floor((d / 1000) % 60),
  };
}

export default function Countdown() {
  // Patriots Family Barbecue — Saturday, August 15, 2026, 2:00 PM
  const target = new Date('2026-08-15T14:00:00-04:00');

  const [t, setT] = useState(diff(target));

  useEffect(() => {
    const id = setInterval(() => setT(diff(target)), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, []);

  const cells = [
    { label: 'Days', v: t.days },
    { label: 'Hrs', v: t.hrs },
    { label: 'Mins', v: t.mins },
    { label: 'Secs', v: t.secs }
  ];

  return (
    <div className="grid grid-cols-4 gap-3 md:gap-5">
      {cells.map((c) => (
        <div key={c.label} className="bg-[#0a1f44] border border-white/10 relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-1 bg-[#c8102e]" />
          <div className="py-6 md:py-8 text-center">
            <div className="font-display text-4xl md:text-6xl text-white tabular-nums">{String(c.v).padStart(2, '0')}</div>
            <div className="font-heading uppercase text-[10px] md:text-xs tracking-[0.3em] text-white/60 mt-1">{c.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
